module.exports = __webpack_public_path__ + "static/media/UniNeueBook.f82798d7.ttf";